import type { LoaderFunction } from "@remix-run/node";
import { json } from "@remix-run/node";

import { withCors } from "~/config/cors";
import ConvertAnonymousAccount from "~/pages/ConvertAnonymousAccount";
import { pageMeta } from "~/utils/meta";

export const meta = pageMeta(
    "Link Account - Parts Companion",
    "Link your anonymous account to a permanent account",
);

export const loader: LoaderFunction = withCors(async ({ request }) => json({}));

export default function LinkAccountRoute() {
    return <ConvertAnonymousAccount />;
}
